"use client"

import { ArrowLeft, ThumbsUp, Tag } from "lucide-react"

interface CareerHeaderProps {
  careerName: string
  description: string
  matchPercentage: number
  category: string
  imageUrl: string
  onBack: () => void
}

export function CareerHeader({
  careerName,
  description,
  matchPercentage,
  category,
  imageUrl,
  onBack,
}: CareerHeaderProps) {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
      <div className="flex items-center gap-4 p-4 sm:p-5">
        <button
          onClick={onBack}
          className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-slate-100 text-slate-500 transition-colors shrink-0"
        >
          <ArrowLeft className="w-4 h-4" />
        </button>

        <img
          alt={`${careerName} illustration`}
          src={imageUrl || "/placeholder.svg"}
          className="w-12 h-12 object-cover rounded-xl border border-slate-200 shrink-0"
        />

        <div className="flex-1 min-w-0">
          <h1 className="text-xl font-bold text-slate-900 leading-tight">{careerName}</h1>
          <p className="text-sm text-slate-500 mt-0.5 line-clamp-2">{description}</p>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <span className="flex items-center gap-1 bg-teal-50 text-teal-700 border border-teal-200 px-2.5 py-1 rounded-full text-xs font-semibold">
            <ThumbsUp className="w-3 h-3" /> {matchPercentage}% Match
          </span>
          <span className="hidden sm:flex items-center gap-1 bg-indigo-50 text-indigo-700 border border-indigo-200 px-2.5 py-1 rounded-full text-xs font-semibold">
            <Tag className="w-3 h-3" /> {category}
          </span>
        </div>
      </div>
    </div>
  )
}
